import API from "../api";

export const fetchMoratoriumListings = () =>
  API.agent().get(`/moratorium-listings`);
export const fetchMoratoriumDetails = () =>
  API.agent().get(`/moratorium-detail`);
